export const themeConfig = {
    token: {
        colorPrimary: 'rgb(0, 122, 51)',
    },
    components: {
        Layout: {
            "headerBg":"var(--main-color)",
            "headerColor":"var(--secondary-color)",
            "bodyBg":"none",
            "footerBg":"none",
            "headerHeight":"var(--header-height)"
        },
/*        Button:{
            "colorText": "var(--secondary-color)",  // Testo nero di default
            "colorTextHover": "var(--third-color)", // Testo bianco in hover
        },*/
/*        Button:{
             colorPrimary: 'var(--main-color)',
             colorPrimaryHover:"var(--main-color-analogous-1)",
             colorPrimaryBorder:"var(--main-color-analogous-1)",
             colorPrimaryActive:"var(--main-color-analogous-2)"
        },*/
        Table:{
            "headerBg":"var(--main-color)",
            "headerSortActiveBg":"var(--main-color)",
            "headerSortHoverBg":"var(--main-color-analogous-1)",
            "headerColor":"var(--secondary-color)",
            "headerSplitColor":"var(--secondary-color)"

        },
        Menu:{
            "itemBg":'var(--main-color)',
            "itemColor":'var(--secondary-color)',
           /* "darkItemBg":'var(--main-color)',
            "darkItemColor":'var(--secondary-color)',*/
            "horizontalItemSelectedBg":"var(--main-color-analogous-2)",
            "horizontalItemSelectedColor":"var(--secondary-color)",
            "itemHoverColor": "var(--third-color)"  // Testo bianco in hover
        },
    },
    hashed: false
}